



export class OrganisationClientVM {
    
    username?: string;
    
    createdOn?: Date;
    
    enabled?: boolean;
    
    disabledOn?: Date;
    
    isRegistered?: boolean;
    
    issuedCredits?: number;
    
}
